import { CHECKBOX_LEVEL, CHECKBOX_GROUP_PROPS } from "../../modules/checkbox_constants"
import { CHECKBOX } from "../../modules/checkbox_constants"
import { JARGON, LSE_INDEX_ENUM } from "../../modules/constants"
import HOOK from "../hooks"

import { createCheckbox } from "../../pages/companiesHouse/pageFunctions/checkboxFunctions"

export const Checkboxes = props => {
  // console.log('Checkboxes props:',props)
  return !!CHECKBOX[props.hook]
    ? CHECKBOX[props.hook].map((checkbox, id) =>
      createCheckbox({
        ...props,
        checkbox,
        enabled: itemEnabled({ ...props, checkbox }),
        tooltipTitle: lockedTooltip({ ...props, checkbox }),
        color: checkbox.COLOR,
        labelColor: checkbox.LABEL_COLOR,
      }))
    : []
}

const groupEnabled = ({ features, hook }) =>
  (CHECKBOX_GROUP_PROPS[hook].LEVEL === CHECKBOX_LEVEL.PREMIUM && features.PremiumCheckboxes) ||
  (CHECKBOX_GROUP_PROPS[hook].LEVEL === CHECKBOX_LEVEL.STANDARD && features.StandardCheckboxes)

// Trial users are locked to the FTSE 100 constituent only within the LSE Group selector
const isTrialLockedLseIndex = ({ checkbox, features, hook }) =>
  hook === HOOK.LSE_INDEX && !!features.Trial && checkbox.BIT !== CHECKBOX[HOOK.LSE_INDEX][LSE_INDEX_ENUM.FTSE_100].BIT

const itemEnabled = props => {
  if (!groupEnabled(props))
    return false

  return !isTrialLockedLseIndex(props)
}

// Explains why a trial-locked checkbox is disabled; other disabled checkboxes keep their own tooltip (if any)
const lockedTooltip = props => isTrialLockedLseIndex(props) ? JARGON.TRIAL_LSE_INDEX_LOCKED : props.checkbox.TOOLTIP_TITLE

